import axios from 'axios';

// 查询排行榜
export function getContributionRank(params) {
  return axios({
    url: '/mall/app/fp/contribution/rank',
    method: 'get',
    params,
  });
}

// 查询排行榜
export function getOrderRank(params) {
  return axios({
    url: '/mall/app/fp/order/rank',
    method: 'get',
    params,
  });
}

// 查询排行榜
export function getSalesRank(params) {
  return axios({
    url: '/mall/app/fp/sales/rank',
    method: 'get',
    params,
  });
}

export function getLiveRooms(params) {
  return axios({
    url: 'https://www.jmzbo.com/api/services/app/Live/GetLiveRooms',
    method: 'get',
    params,
  });
}
//查询扶贫产品,只查普惠平台的
export function getFpProducts(params) {
  return axios({
    url: '/mall/app/products',
    method: 'get',
    params,
  });
}
//再来一单
export function buyAnotherOne(data) {
  return axios({
    url: '/mall/app/order/buyAgain/' + data.orderId,
    method: 'post',
    data: data,
  });
}
//批量添加到购物车
export function batchAddcart(data) {
  return axios({
    url: '/mall/app/cart/batch',
    method: 'post',
    data: data,
  });
}
//查询订单
export function getFpOrder(params) {
  return axios({
    url: '/mall/app/order',
    method: 'get',
    params,
  });
}
//修改订单收货地址
export function modifyDetailAddress(data) {
  return axios({
    url: '/mall/app/order/address/' + data.orderId,
    method: 'put',
    data: data,
  });
}
//查询订单
export function getFpOrderDetail(id) {
  return axios({
    url: '/mall/app/order/' + id,
    method: 'get',
  });
}

//查询支付结果
export function getPayResult(id) {
  return axios({
    url: '/mall/app/order/pay/result/' + id,
    method: 'get',
  });
}

//扶贫接口增加浏览量
export function increaseFpClickCount() {
  return axios({
    url: '/mall/app/fp/click',
    method: 'put',
  });
}

//用户手动核销
export function pickupCode(data) {
  return axios({
    url: '/mall/app/exchange/pickup_code/verification_code',
    method: 'post',
    data: data,
  });
}

//调用主题页入口统计接口
export function sumipApi(name) {
  return axios({
    url: 'https://hgtest.jmzgo.com/api/SumIp?name=' + name,
    method: 'get',
  });
}
